export default class   UserData {
    constructor(
        public primerNombre?: string  ,
        public segundoNombre?: string  ,
        public primerApellido?: string  ,
        public estadoCivil?: string  ,
        public celular?: string  ,
        public email1?:string,
        public email2?:string,
        public codPersona?:string

    ){}
}